import { TimberBuyerContextProvider } from '@features/TimberBuyer/TimberBuyerContext'
import { getTimberBuyerQuery } from '@services/queryOptions'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/timberbuyer/$timberBuyerId')({
  component: TimberBuyerLayout,
  staticData: {
    breadcrumb: 'Tømmerkjøper',
  },
})

function TimberBuyerLayout() {
  const { timberBuyerId } = Route.useParams()
  const { data, isLoading, isError } = useQuery(getTimberBuyerQuery(timberBuyerId))

  return (
    <TimberBuyerContextProvider value={{ data, isLoading, isError }}>
      <Outlet />
    </TimberBuyerContextProvider>
  )
}
